import React, { useEffect } from 'react';
import { Box, CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { WebPhoneProvider } from '../../contexts/WebPhoneContext';
import { AuthProvider } from '../../contexts/AuthContext';
import WebPhoneStandalone from './WebPhoneStandalone';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

const WebPhonePopup: React.FC = () => {
  useEffect(() => {
    // Set document title
    document.title = 'WebPhone';
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <WebPhoneProvider>
          <Box
            sx={{
              width: '100vw',
              height: '100vh',
              overflow: 'hidden',
              bgcolor: 'background.default',
            }}
          >
            <WebPhoneStandalone />
          </Box>
        </WebPhoneProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default WebPhonePopup;
